/**
 * Los nombres con que se cuentan los cambios de estructura de la obra: lo que cuelga de un
 * nodo, por colección, y por qué un rubro no se toca. Los usan el diálogo de unificar y las
 * tarjetas del copiloto. Son los mismos textos que `tools.escritura.js` del backend.
 */

const COLECCIONES = {
  Presupuesto: 'presupuestos',
  MovimientoCaja: 'imputaciones de caja',
  NotaDePedido: 'notas de pedido',
  OrdenPago: 'órdenes de pago',
  CuotaPago: 'cuotas de pago',
  PlanPago: 'planes de pago',
  Inconveniente: 'inconvenientes',
  PropuestaObra: 'propuestas pendientes',
  RegistroAvance: 'registros de avance',
  HitoObra: 'hitos',
};

const MOTIVOS = {
  sin_subrubros: 'no tiene subrubros',
  varios_subrubros: 'tiene varios subrubros',
  con_items: 'tiene ítems',
  rubro_no_encontrado: 'no lo encontré',
  nombre_ambiguo: 'hay más de uno con ese nombre',
  ciclo_de_dependencias: 'el cronograma quedaría con un ciclo de dependencias',
  pasos_que_se_pisan: 'dos pasos tocan lo mismo',
  falta_nombre_final: 'el rubro y su subrubro se llaman distinto, hay que elegir cuál nombre queda',
  referencia_no_reapuntable: 'algo que apunta al subrubro no se puede pasar al rubro',
  valores_en_conflicto: 'el rubro y el subrubro tienen valores propios distintos',
  invariante_roto: 'la obra quedaría inconsistente',
};

export const nombreDeColeccion = (c) => COLECCIONES[c] || c;

/** `null` si el motivo no es uno conocido: cada pantalla decide qué mostrar en ese caso. */
export const textoDeMotivo = (m) => MOTIVOS[m] || null;

export const conMayuscula = (t) => (t ? t.charAt(0).toUpperCase() + t.slice(1) : t);
